import React from "react";
import { Mail, Phone, MessageCircle } from "lucide-react";

export const CONTACT_METHODS = [
  { id: "email", label: "E-pošta", icon: Mail },
  { id: "phone", label: "Klic", icon: Phone },
  { id: "whatsapp", label: "WhatsApp", icon: MessageCircle },
];

export const CONTACT_METHOD_LABEL = {
  email: "E-pošta",
  phone: "Klic",
  whatsapp: "WhatsApp",
};

export default function ContactMethodPicker({ value, onChange, testid = "contact-method" }) {
  return (
    <div className="grid grid-cols-3 gap-2" data-testid={testid}>
      {CONTACT_METHODS.map((m) => {
        const Icon = m.icon;
        const active = value === m.id;
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => onChange(m.id)}
            data-testid={`${testid}-${m.id}`}
            className={`flex flex-col items-center justify-center gap-1.5 rounded-xl border px-3 py-3 text-xs font-semibold transition-colors ${
              active
                ? "border-[var(--vp-primary)] bg-[var(--vp-primary)]/5 text-[var(--vp-primary)]"
                : "border-[var(--vp-border)] bg-white text-[var(--vp-muted)] hover:border-[var(--vp-primary)]/40"
            }`}
          >
            <Icon size={18} />
            {m.label}
          </button>
        );
      })}
    </div>
  );
}
